import { TaxonomyNodeType } from '~types'

export interface FilterableItem {
  foodRestriction?: TaxonomyNodeType[]
  restaurantLocation?: TaxonomyNodeType[]
  // Add other filterable properties as needed
}

export interface FilterCriteria {
  [key: string]: string
}

/**
 * Filters an array of items based on selected taxonomy filters
 * Returns items that match ALL selected filters
 */
export function filterDataByTaxonomy<T extends FilterableItem>(data: T[], filters: FilterCriteria): T[] {
  if (!data || data.length === 0) return []

  if (Object.keys(filters).length === 0) return data

  return data.filter(item => {
    return Object.entries(filters).every(([filterType, filterValue]) => {
      switch (filterType) {
        case 'foodRestriction':
          return item.foodRestriction?.some(restriction => restriction.value === filterValue)

        case 'restaurantLocation':
          return item.restaurantLocation?.some(location => location.value === filterValue)

        default:
          // Return true for unknown filter types so they don't block the item
          return true
      }
    })
  })
}
